import markdownComponents from '../../common/markdownComponents';
import Markdown from '../../common/Markdown/Markdown';

type Props = {
  hotelName: string;
  message: string;
};

const Message = ({ message, hotelName }: Props) => {
  return (
    <div className="rounded-md border-gray-200 bg-white p-6 sm:border">
      <p className="mb-4 text-large font-bold text-black">{hotelName}</p>
      <Markdown components={markdownComponents}>{message}</Markdown>
    </div>
  );
};

export default Message;
